import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

function SelectField({
  label,
  name,
  placeholder,
  onChange,
  options,
  selectedCategory = null,
  errorText = '',
  showError = false,
  clearable = false,
  className = '',
  required = false,
  formClassName = '',
}) {
  const borderColor = showError && errorText !== '' ? '#ce3c5c' : ''

  return (
    <div className={`form-group ${formClassName}`}>
      <label>
        {label}:
        {required
          && <b> *</b>
        }
      </label>
      <Select
        name={name}
        value={selectedCategory}
        options={options}
        placeholder={placeholder}
        onChange={onChange}
        style={{ borderColor }}
        className={className}
        clearable={clearable}
      />
      {showError && (
        <div className="error-message">
          <span className="text">{errorText}</span>
        </div>
      )}
    </div>
  )
}

SelectField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  selectedCategory: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  errorText: PropTypes.string,
  showError: PropTypes.bool,
  clearable: PropTypes.bool,
  className: PropTypes.string,
  required: PropTypes.bool,
  formClassName: PropTypes.string,
}

export default SelectField
